export default function log(message, ...otherMessages) {
    if (process.env.NODE_ENV === 'production') {
        return;
    }
    console.debug(message, otherMessages);
}
